import { SVGProps, memo } from "react";

const InviteSentIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={props.width || "22"} height={props.height || "22"} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3802 20.8622C13.6504 21.0981 14.0738 20.9811 14.1846 20.6399L20.3532 1.64245C20.4889 1.22442 20.058 0.847231 19.6616 1.0371L1.64762 9.66567C1.32413 9.82062 1.2642 10.2557 1.53375 10.4924L5.70656 14.1556C5.88291 14.3104 6.14319 14.3217 6.33234 14.1829L13.1414 9.18347L9.0871 16.5943C8.97447 16.8001 9.02016 17.0566 9.19695 17.2109L13.3802 20.8622Z" stroke={props.stroke || "#0810FF"} strokeWidth={props.strokeWidth || "1.6"} strokeLinejoin="round"/>
    </svg>
  );
};

export default memo(InviteSentIcon);
